module.exports = __webpack_public_path__ + "static/media/LifeIsNotFair.81412e1c.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/components/Motivation/LifeIsNotFair/LifeIsNotFair.mp4
// module id = 395
// module chunks = 0